<template>
    <v-container class="my-10 white--text text-center" style="height:300px;  position: relative;">
        <div class="centered">
            <h3 class="mb-8">Get your store sustainable in minutes </h3>
            <p class="mb-8 mediumBody">Your business, your customers, our planet.</p>
            <v-btn class="combustion rounded-0 smallBody" router to="/register">
                Get started
            </v-btn>
        </div>
    </v-container>
</template>

<script>

export default {
    name:'ReadyToGetStarted'
}
</script>
